/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import { ITableVisualizationStaticProperties } from '../types/tableVisualizationTypes';
import { IMultiLevelDataServiceDataLayout, IMultiLevelDataset } from '../../../../store/types/MultiLevelDatasetTypes';

export type DataLayoutConverter = (staticProperties: ITableVisualizationStaticProperties, dataset: IMultiLevelDataset) => IMultiLevelDataServiceDataLayout;

export const generateDataLayout: DataLayoutConverter = (staticProperties, dataset) => {
    const res: IMultiLevelDataServiceDataLayout = {
        details: [],
        groups: staticProperties.groups.map((group) => group.hierarchicalFieldName),
        aggregations: [],
        distinctFields: staticProperties.distinctFields,
        filters: dataset.summary.filters,
        order: staticProperties.order,
        limit: dataset.summary.limit
    };

    if (staticProperties.showDetails) {
        res.details = staticProperties.columns
            .filter((column) => (column.type === 'column'))
            .map((column) => ({
                field: column.hierarchicalFieldName,
                detailType: column.detailType || ''
            }));
    }

    const aggregations = staticProperties.columns
        .filter((column) => (column.type === 'column'))
        .filter((column) => (column.showSummary))
        .map((column) => ({
            field: column.hierarchicalFieldName,
            aggregationType: column.aggregationType || '',
            aggregationFunction: column.aggregationFunction || '',
            timeBalanceFunctionName: column.timeBalanceFunctionName || 'TimeBalanceDefault'
        }));

    if (aggregations.length) {
        res.aggregations = aggregations;
    }

    return res;
};
